module.exports = __webpack_public_path__ + "static/media/co-cardless-logo.14f73a3b.svg";